import Icon from "@shared/components/ui-kit/icons/Icon.web";
import { useTranslation } from "@shared/utils/internationalization";
import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import type { AssignedSeatInformationSharedProps } from "./AssignedSeatInformation.props";

export default function AssignedSeatInformation({
  identifier,
  segment_identifier,
  location_identifier,
  isAccessible,
}: AssignedSeatInformationProps) {
  const { t } = useTranslation("seating");

  return (
    <Flex alignContent="center" gap="sm" flexWrap="wrap">
      {segment_identifier && (
        <Flex alignItems="center" data-testid="segment_identifier-container">
          <Box
            border="1px solid"
            borderColor="gray.500"
            borderRadius="xl"
            padding="2px 8px"
            mr="2xs"
          >
            <Text fontSize="xs" color="font.dark">
              {t("Sec")}
            </Text>
          </Box>
          <Text fontSize="sm" color="font.dark">
            {segment_identifier}
          </Text>
        </Flex>
      )}
      {location_identifier && (
        <Flex alignItems="center" data-testid="location_identifier-container">
          <Box
            border="1px solid"
            borderColor="gray.500"
            borderRadius="xl"
            padding="2px 8px"
            mr="2xs"
          >
            <Text fontSize="xs" color="font.dark">
              {t("Row")}
            </Text>
          </Box>
          <Text fontSize="sm" color="font.dark">
            {location_identifier}
          </Text>
        </Flex>
      )}
      {identifier && (
        <Flex alignItems="center" data-testid="identifier-container">
          <Flex
            direction="row"
            alignItems="center"
            border="1px solid"
            borderColor="gray.500"
            borderRadius="xl"
            padding="2px 8px"
            mr="2xs"
          >
            <Text
              fontSize="xs"
              color="font.dark"
              data-testid="identifier-text-label"
            >
              {location_identifier ? t("Seat") : t("Area")}
            </Text>
            {isAccessible && (
              <Icon.Wheelchair
                width="element.md"
                height="element.md"
                ml="2xs"
              />
            )}
          </Flex>
          <Text fontSize="sm" color="font.dark">
            {identifier}
          </Text>
        </Flex>
      )}
    </Flex>
  );
}

export type AssignedSeatInformationProps =
  AssignedSeatInformationSharedProps & {
    // Add any web specific props here.
  };
